'use strict';

angular.module('atex.aceui.service').factory('ValidationService',
  [function() {

    var createValidationContext = function() {
      var widgetsToValidate = [];

      return {
        /**
         * Registers a validation function to be called when the framework requests widgets to validate their state.
         *
         * @param widgetId {string} The id of the widget as passed in $scope.widgetId
         * @param validationFn {object} A validation function that returns a ValidationResult.
         *
         * A ValidationResult is an object with the following properties:
         *
         * {
         *   isValid: {boolean},
         *   message: {string} (optional)
         * }
         *
         */
        register: function(widgetId, validationFn) {
          if (typeof validationFn !== 'function') {
            throw atex.aceui.error.Error({
              origin: 'ValidationService',
              cause: 'Trying to register a non-function object!'
            });
          }

          widgetsToValidate.push({
            widgetId: widgetId,
            validationFn: validationFn
          });
        },

        validate: function() {
          var results = [];

          widgetsToValidate.forEach(function(widget) {
            var result = widget.validationFn();
            if (result?.hasOwnProperty('isValid')) {
              result.widgetId = widget.widgetId;
              results.push(result);
            }
            else {
              console.error('Widget with id ' + widget.widgetId + ' returned a bad validation result: ' + result);
            }
          });

          return results;
        }

      };
    }

    return {
      /**
       * Create a new validation context
       */
      instantiate: function() {
        return createValidationContext();
      }

    };
  }]
);
